import { Box } from '@material-ui/core';
import { Nav } from './nav';

import { TWindowType } from '../../interfaces';

import { useStyles } from './style';

export const Navigation = () => {
  const classes = useStyles();
  const navValues: TWindowType[] = ['softphone', 'chat', 'settings'];

  return (
    <Box className={classes.wrapper}>
      {navValues.map((i) => (
        <Nav type={i} key={i} />
      ))}
    </Box>
  );
};
